import React from "react";
import { FormControl, FormHelperText, Radio, Typography } from "@mui/material";
import { capitalizeAndCleanUnderscore } from "@utils";
import StatusChip from "src/components/collections/StatusChip";
import { ButtonGroup, ButtonOption } from "./HyroRadioGroup.styles";

const HyroRadioGroup = ({
  value,
  options,
  testId,
  isReadOnly,
  onChange,
  label,
  showLabel,
  status,
  index,
  fieldType,
  error
}) => {
  const handleChange = ({ target }) => onChange(target.value);

  return (
    <FormControl disabled={isReadOnly} data-testid={testId || `${fieldType}-${index}-${value}`}>
      {showLabel && <Typography variant="subtitle2" mb={1}>{label}</Typography>}

      <ButtonGroup value={value} onChange={e => !isReadOnly && handleChange(e)}>
        {options.map(option => (
          <ButtonOption
            key={option.key}
            value={option.key}
            label={capitalizeAndCleanUnderscore(option.label)}
            disabled={isReadOnly}
            checked={value === option.key}
            data-testid={testId ? `${testId}-${option.key}` : `${fieldType}-${index}-option-${option.key}${value === option.key ? "-checked" : ""}`}
            control={<Radio />}
          />
        ))}
      </ButtonGroup>

      {!error && <FormHelperText data-testid={`${fieldType}-${index}-helper`}><StatusChip status={status} /> {error}</FormHelperText>}
      {error && <FormHelperText data-testid={`${fieldType}-${index}-error`} sx={{ color: "error.500" }}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default HyroRadioGroup;
